module.exports = __webpack_public_path__ + "static/delivery-plan-f0146a349ec9af6e82774320598c8f78.png";